<script>
import InfoCardPageForm from "@/views/menu/info-card-page/infoCardPageForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    infoCardPageService: "infoCardPageService",
    infoBoxService: "infoBoxService",
    toastService: "toastService"
  }
})
export default class InfoCardPageEdit extends mixins(InfoCardPageForm) {
  formId = "edit-info-card-page-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        handle: this.save
      }
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
        await this.infoCardPageService.update(this.model.id, this.model);
      this.$router.push("/info-card-pages/list");
      this.toastService.success(this.translations.success.infoCardPage_update);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle () {
    return this.translations.pageTitles.infoCardPages_edit;
  }

  async afterCreate () {
    this.model = await this.infoCardPageService.read(this.$route.params.id);

    if (this.model.idInfoBox !== null) {
      this.model.infoBoxData = await this.infoBoxService.read(this.model.idInfoBox);
      this.model.infoBoxData.enableInfoBox = this.model.infoBoxData.isEnabled;
    } else {
      this.model.infoBoxData = {
        enableInfoBox: false,
        code: "",
        width: null,
        height: null,
        x: null,
        y: null,
        localizations: [],
      };
    }

    this.isReady = true;
  }
}
</script>
